import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const IconPause = props => {
  const $ = _c(4);
  const t0 = props.fill || "#FFFFFF";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="m0 1.01c0-.56.44-1.01 1.01-1.01h1.98c.56 0 1.01.45 1.01 1.01v11.98c0 .56-.44 1.01-1.01 1.01h-1.98c-.56 0-1.01-.45-1.01-1.01zm7 0c0-.56.44-1.01 1.01-1.01h1.98c.56 0 1.01.45 1.01 1.01v11.98c0 .56-.44 1.01-1.01 1.01h-1.98c-.56 0-1.01-.45-1.01-1.01z" fillRule="evenodd" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== props || $[2] !== t0) {
    t2 = <svg viewBox="0 0 11 14" role="presentation" aria-hidden="true" focusable="false" width="20px" height="20px" fill={t0} {...props}>{t1}</svg>;
    $[1] = props;
    $[2] = t0;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
IconPause.propTypes = {
  fill: PropTypes.string
};
export default IconPause;